<template>
    <li>
        <a
            href=""
            class="info date"
            @click.prevent="open = !open"
            v-if="this.title !== 'Todays bookings'"
        >
            {{ $date(date.replace(/ /g, "/"), "dd mm YYYY").format("ddd D MMM") }}

            <chevron-down-icon class="arrow" v-if="!open" /><chevron-up-icon class="arrow" v-else />
        </a>
        <ul v-if="open">
            <li v-for="less in lesson" :key="less.id">
                <router-link class="info link" :to="goToLink(less)">
                    <span class="time">{{
                        $date("2020-12-08 " + less.start).format("HH:mm") +
                        " - " +
                        $date("2020-12-08 " + less.end).format("HH:mm")
                    }}</span>
                    <span class="user" v-if="!less.guest_name"
                        >{{ less.player.first_name }} {{ less.player.last_name }}</span
                    >
                    <span v-else>{{ less.guest_name }}</span>
                </router-link>
            </li>
        </ul>
    </li>
</template>

<script>
import { ChevronUpIcon, ChevronDownIcon } from "vue-feather-icons";
export default {
    name: "",
    components: { ChevronUpIcon, ChevronDownIcon },
    props: ["lesson", "date", "title"],
    data() {
        return {
            open: false,
        };
    },
    created() {
        if (this.title == "Todays bookings") {
            this.open = true;
        }
    },
    methods: {
        goToLink(less) {
            if (this.$date(less.date).isBefore(this.$date())) {
                return { name: "proPlayerLesson", params: { id: less.player_id, lesson: less.id } };
            } else {
                return { name: "proLessonChange", params: { id: less.id } };
            }
        },
        expand() {
            this.open = !this.open;
        },
        closeIt() {
            this.open = false;
        },
        openIt() {
            this.open = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.info {
    background: #1df19f;
    color: $green_0;
    font-size: 16px;
    margin-bottom: 10px;
    text-decoration: none;
    position: relative;
    &.date {
        background: #eef5f2;
        color: #b2bab3;
    }
    &.link {
        background: #bbf8e0;
    }
    .time {
        margin-right: 40px;
    }
    .user {
        position: absolute;
        left: 140px;
    }
}
.arrow {
    position: absolute;
    right: 20px;
    top: 15px;
    pointer-events: none;
}
</style>
